export default __webpack_public_path__ + "static/media/morocco-flag.7e8a15d4.png";